export const primaryColor = "rgba(102,37,103,0.75)";
export const googleBooksAPIKey = process.env.REACT_APP_GOOGLE_BOOKS_API_KEY;
